import React from 'react';
import ReactDOM from 'react-dom';
import AllQuestions from '../../components/modules/questionAndAnswers/AllQuestions.jsx';

const element = document.getElementById('all-questions');
if (element !== null) {
    ReactDOM.render(<AllQuestions slug={element.dataset.slug} />, element);
}
